export const IntegrationAppIds = {
  QUICKBOOKS_QA: 1920452,
  QUICKBOOKS_PROD: 542129,
  XERO_QA: 1208251,
  XERO_PROD: 235997
};